import { LinkButton, OnlyButton } from "./buttons";
import {
  Section,
  SectionWithContainer,
  Container,
  SectionTitleSubTitle,
  TwoColSection,
  TwoColSection2,
} from "./sectionComponents";
import { Navbar, MobileNav } from "./navbar";
import Footer from "./footer/Footer";
import SliderSwip from "./SliderSwip";
import { ServiceCard, TeamMemberCard, ServiceCard3 } from "./Cards";
import Whatsapp from "./ContactButton/WhatsApp";
import Call from "./ContactButton/Call";
import Bannner from "./banner/Bannner";
import Accordion from "./Cards/Accordion";
import Reviews from "./Cards/Reviews";
import CommanBanner from "./banner/CommanBanner";

export {
  Bannner,
  CommanBanner,
  LinkButton,
  OnlyButton,
  Section,
  SectionWithContainer,
  SectionTitleSubTitle,
  Container,
  Navbar,
  MobileNav,
  Footer,
  SliderSwip,
  ServiceCard,
  TwoColSection,
  Whatsapp,
  Call,
  TwoColSection2,
  Accordion,
  Reviews,
  TeamMemberCard,
  ServiceCard3,
};
